import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { gray80 } from '../../../../constants/colors';
import MypageCompleteCard from '../../../uiParts/card/MypageCompleteCard';
import CustomSnackbar from '../../../uiParts/form/CustomSnackbar';
import SideBar from '../../../uiParts/menu/SideBar';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../../../contexts/auth';
import { useAuthRedirect } from '../../../../hooks/useAuthRedirect';
import MetaTitle from '../../../utils/MetaTitle';
import { usePageLayout } from '../../../../hooks/usePageLayout';

interface LocationState {
  fromCompanyEdit?: boolean;
}

const CompanyEditComplete: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { user, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  // 未認証ならログイン画面へ退避する（元URLは ?redirect= で引き継ぐ。#3203）
  useAuthRedirect();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const isValidAccess = Boolean(state?.fromCompanyEdit);
  const { sideBarCollapsed, toggleSidebar, styles: layoutStyles } = usePageLayout();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isLoading) return;
    if (user === null) {
      return;
    }

    if (!isValidAccess) {
      navigate('/company');
    }
  }, [user, isLoading, navigate, isValidAccess]);

  if (!isValidAccess) {
    return null;
  }

  return (
    <Box sx={layoutStyles.pageWrapper}>
      <MetaTitle />
      <Box sx={[layoutStyles.sidebar, sideBarCollapsed && layoutStyles.sidebarCollapsed]}>
        <SideBar collapsed={sideBarCollapsed} onToggle={toggleSidebar} />
      </Box>
      <Box
        sx={[
          layoutStyles.pageContent,
          sideBarCollapsed && layoutStyles.pageContentCollapsed,
          layoutStyles.pageContentNoFooter,
          layoutStyles.fullHeightContent,
          {
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        <MypageCompleteCard
          IconComponent={CheckCircleIcon}
          iconColor={gray80}
          titleText={'会社情報の変更が完了しました'}
          titleStyle={{ fontWeight: '500' }}
          isMessageCenter
          messageText={''}
          buttonText="アカウント管理へ"
          targetPath="/company"
        />
      </Box>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text=""
        infoText="前のページに戻れません。"
      />
    </Box>
  );
};

export default CompanyEditComplete;
